import React, {
    createContext,
    useState,
    useContext,
    useCallback,
} from "react";
import { getApiInstance } from "../utils/api";
import { useZone } from "./ZoneContext";

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
    const [searchElements, setSearchElements] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { selectedZone } = useZone();

    const fetchAllData = useCallback(async () => {
        if (!selectedZone || !selectedZone.value) return;

        setLoading(true);
        setError(null);

        setSearchElements([]);

        const api = getApiInstance();

        try {
            const [
                obrasResponse,
                gestoresResponse,
                intermediariosResponse,
                obrasMenoresResponse,
                productoresResponse,
            ] = await Promise.all([
                api.get(
                    `/api/Obra/GetObrasFromZona/${selectedZone.value}/1/es`
                ),
                api.get(
                    `/api/Proveedores/GetProveedoresByZona?CodZona=${selectedZone.value}`
                ),
                api.get(
                    `/api/Intermediarios/GetIntermediariosByZona/${selectedZone.value}`
                ),
                api.get(
                    `/api/ObraMenor/GetObrasMenoresFromUser/${selectedZone.value}`
                ),
                api.get(
                    `/api/Productores/GetProductoresByZona/${selectedZone.value}`
                ),
            ]);

            const elementosDict = {
                centroProductor: obrasResponse.data,
                gestores: gestoresResponse.data,
                intermediarios: intermediariosResponse.data,
                obrasMenores: obrasMenoresResponse.data,
                productor: productoresResponse.data,
            };

            setSearchElements(elementosDict);
        } catch (err) {
            setError(
                "No se han podido cargar los datos. Vuelve a intentarlo más tarde."
            );
            console.error("Error al cargar los datos:", err);
        } finally {
            setLoading(false);
        }
    }, []);

    const value = {
        searchElements,
        loading,
        error,
        fetchAllData,
    };

    return (
        <SearchContext.Provider value={value}>
            {children}
        </SearchContext.Provider>
    );
};

export const useSearch = () => {
    const context = useContext(SearchContext);
    if (context === undefined) {
        throw new Error("useSearch debe ser usado dentro de un SearchProvider");
    }
    return context;
};
